module.exports = __webpack_public_path__ + "img/download-icon.113e041b.svg";